import { zUid } from "src/types/zUid";
import { z } from "zod";

export const zAttrFormulaWithFinancialView = z.object({
  view: z.literal("FormulaWithFinancialView"),
  currencyObjectId: zUid,
  labelAttr: zUid,
  signLocation: z.string(),
});
